@let versionData = this.$appVersionData();
@let isLoading = !!(isLoading$ | async);
@let isDesktop = deviceService.isDesktop$ | async;

@if (isDesktop) {
  <!--      TODO после ухода со slack стало неактуальным-->
  <!--  <button-->
  <!--    class="complete-button h-[28px]! mx-3 w-[115px]! mt-1"-->
  <!--    tuiButton-->
  <!--    data-tally-open="w2OGWL"-->
  <!--    data-tally-emoji-text="👋"-->
  <!--    data-tally-emoji-animation="wave"-->
  <!--    data-email=""-->
  <!--    [attr.data-version]="versionData?.version || 'unknown'"-->
  <!--    [attr.data-email]="(user$ | async)?.email"-->
  <!--    appearance="outline"-->
  <!--  >-->
  <!--    <span class="x-font-body-5-bold">{{-->
  <!--      'core.sidebar.feedback_btn' | translate-->
  <!--    }}</span>-->
  <!--  </button>-->
  @if (versionData) {
    <section
      class="text-[8px] opacity-60 absolute x-text-dark-main w-[150px] left-[35px] text-center bottom-1.5"
    >
      v{{ versionData.version }} {{ versionData.date }}
    </section>
  }
} @else {
  <aside
    [tuiSkeleton]="isLoading && !isDesktop"
    [ngClass]="{ 'rounded-(--tui-radius-l)': isLoading && !isDesktop }"
  >
    <section class="mb-5">
      <!--      TODO после ухода со slack стало неактуальным-->
      <!--      <button-->
      <!--        class="w-full"-->
      <!--        data-tally-open="w2OGWL"-->
      <!--        data-tally-emoji-text="👋"-->
      <!--        data-tally-emoji-animation="wave"-->
      <!--        data-email=""-->
      <!--        [attr.data-version]="versionData?.version || 'unknown'"-->
      <!--        [attr.data-email]="(user$ | async)?.email"-->
      <!--        appearance="accent"-->
      <!--        tuiButton-->
      <!--      >-->
      <!--        {{ 'core.sidebar.feedback_btn' | translate }}-->
      <!--      </button>-->
    </section>

    @if (versionData) {
      <section class="text-xs text-center">
        v{{ versionData.version }} {{ versionData.date }}
      </section>
    }
  </aside>
}
